import React from 'react';
import { Redirect } from 'react-router-dom';
import analytics from '../lib/analytics';
const PageNotFound = () => {
    analytics.track('PAGE_NOT_FOUND');
    return React.createElement(Redirect, { to: '/' });
};
export default PageNotFound;
